import {ProductVariationsComponent} from "./component/product-variations";

require("@babel/polyfill");
// require("./utils/events.ts");

import {AccordionComponent} from "./component/accordion";
import {Application} from "./application/application";
import {ComponentService} from "./service/component";
import EventsHandler from "./service/events";
import {AnimationService} from "./service/animation";
import {ProductGalleryComponent} from "./component/product-gallery";
import {ProductImageWithVideoComponent} from "./component/product-image-with-video";
import {ProductSlidesComponent} from "./component/product-slides";
import {ProductFiltersComponent} from "./component/product-filters";
import {ViewportService} from "./service/viewport";
import {ProductConfiguratorComponent} from "./component/product-configurator";

(($) => $(() => {

    let components = new ComponentService();
    (<any>window).events = undefined === (<any>window).events ? new EventsHandler() : (<any>window).events;
    components.addComponent('.js-accordion', AccordionComponent, 'AccordionComponent');
    components.addComponent('.js-product-filters', ProductFiltersComponent, 'ProductFiltersComponent');
    components.addComponent('.js-product-configurator', ProductConfiguratorComponent, 'ProductConfiguratorComponent');
    components.addComponent('.js-product-slides', ProductSlidesComponent, 'ProductSlidesComponent');
    components.addComponent('.js-product-image-with-video', ProductImageWithVideoComponent, 'ProductImageWithVideoComponent');
    components.addComponent('.js-product-gallery', ProductGalleryComponent, 'ProductGalleryComponent');
    components.addComponent('.js-product-variations', ProductVariationsComponent, 'ProductVariationsComponent');
    new Application(components, (<any>window).events, null, new AnimationService());
    new ViewportService((<any>window).events).start();

}))(jQuery);